/*
 * @Description:流程管理--阶段流程设置
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 */
export default {
  赢率: '赢率',
  执行: '执行',
  动作: '动作',
  空任务: '空任务',
  审批任务: '审批任务',
  新增流程: '新增流程',
  添加任务: '添加任务',
  编辑任务: '编辑任务',
  流程名称: '流程名称',
  对象字段: '对象字段',
  适用范围: '适用范围',
  阶段名称: '阶段名称',
  显示赢率: '显示赢率',
  商机状态: '商机状态',
  结束节点: '结束节点',
  节点名称: '节点名称',
  条件类型: '条件类型',
  请选择条件类型: '请选择条件类型',
  '填写/编辑对象字段': '填写/编辑对象字段',
  新增对象数据: '新增对象数据',
  对象数据如需审批则完成规则为: '对象数据如需审批则完成规则为',
  审批通过后可完成该任务: '审批通过后可完成该任务',
  审批发起后可完成该任务: '审批发起后可完成该任务',
  触发规则: '触发规则',
  触发方式: '触发方式',
  请选择触发方式: '请选择触发方式',
  设置节点限定处理时间: '设置节点限定处理时间',
  请选择节点限定时间: '请选择节点限定时间',
  通知规则: '通知规则',
  接收人: '接收人',
  标题: '标题',
  请选择接收人: '请选择接收人',
  请输入标题: '请输入标题',
  标题不能超过150个字符: '标题不能超过150个字符',
  消息内容: '消息内容',
  添加消息通知: '添加消息通知',
  消息接收人: '消息接收人',
  节点信息: '节点信息',
  节点必做任务: '节点必做任务',
  请输入节点名称: '请输入节点名称',
  节点显示设置: '节点显示设置',
  以下是结束节点: '以下是结束节点',
  全部商机阶段: '全部商机阶段',
  流程发起对象: '流程发起对象',
  流程绘制: '流程绘制',
  流程发起字段: '流程发起字段',
  阶段流程设置: '阶段流程设置',
  阶段流程编辑: '阶段流程编辑',
  阶段节点信息: '阶段节点信息',
  任务列表: '任务列表',
  消息列表: '消息列表',
  阶段流程新增: '阶段流程新增',
  提交数据失败: '提交数据失败',
  '添加云文档/附件': '添加云文档/附件',
  填写对象下字段: '填写对象下字段',
  选择的商机阶段: '选择的商机阶段',
  是否支持跨阶段: '是否支持跨阶段',
  修改字段状态失败: '修改字段状态失败',
  获取字段列表失败: '获取字段列表失败',
  至少要选择一个阶段: '至少要选择一个阶段',
  获取全局字段列表失败: '获取全局字段列表失败',
  获取对象详情数据失败: '获取对象详情数据失败',
  请为选择的所有阶段设置赢率: '请为选择的所有阶段设置赢率',
  请为选择的所有阶段设置商机状态: '请为选择的所有阶段设置商机状态',
  '取消后本次更改不生效，是否确认？': '取消后本次更改不生效，是否确认？',
  流程阶段设置: '流程阶段设置',
  映射至烽火: '映射至烽火',
  映射至外部系统: '映射至外部对象',
  添加任务字段: '添加任务字段'
};
